import api from "@/lib/api";

export const listInstallments = () => api.get("/installments").then((r) => r.data);
export const createInstallment = (payload) => api.post("/installments", payload).then((r) => r.data);
export const payInstallment = (id, account_id) => api.post(`/installments/${id}/pay`, { account_id }).then((r) => r.data);
export const payCustomInstallment = (id, amount, date, source, account_id) =>
  api.post(`/installments/${id}/pay-custom`, { amount, date, source, account_id }).then((r) => r.data);
export const deleteInstallment = (id) => api.delete(`/installments/${id}`).then((r) => r.data);
export const setInstallmentStatus = (id, status) =>
  api.patch(`/installments/${id}/status`, { status }).then((r) => r.data);
